import { useQuery } from "@tanstack/react-query";
import { getTribes } from "../api/api";
import { useSelector } from "react-redux";
import { Tribe, TribeUser } from "../types/tribes.types";

interface UseUserInTribeResult {
  isUserInTribe: boolean;
  userTribe: Tribe | null;
  isLoading: boolean;
  error: Error | null;
}

export const useUserInTribe = (event_id: string): UseUserInTribeResult => {
  const { user } = useSelector((state: any) => state.user);

  const { data, isLoading, error } = useQuery({
    queryKey: ["userInTribe", event_id, user?._id],
    queryFn: async () => {
      const response = await getTribes({
        event_id,
        search_query: "",
        page: 1,
        limit: 10,
        sortBy: "createdAt",
        order: -1,
      });

      if (response.statusCode !== 200) {
        throw new Error("Failed to fetch tribes");
      }

      const tribes = response.data.docs as Tribe[];

      // Find the tribe that the user is in
      const userTribe = tribes.find((tribe) =>
        tribe.tribeUsers?.some(
          (tribeUser: TribeUser) => tribeUser.user_id === user?._id
        )
      );

      return {
        isUserInTribe: !!userTribe,
        userTribe: userTribe || null,
      };
    },
    enabled: !!event_id && !!user?._id,
  });

  return {
    isUserInTribe: data?.isUserInTribe ?? false,
    userTribe: data?.userTribe ?? null,
    isLoading,
    error: error as Error | null,
  };
};
